/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const TEAL = '#00798E';

/**
 * Dismissible keyboard-shortcut hint strip. Dismissal is remembered per
 * `storageKey` in localStorage (best-effort — storage may be unavailable).
 *
 *   items    : [{ k: 'Ctrl+S', label: 'Save' }, ...]
 *   children : custom content (used instead of `items` when provided)
 */
export default function KeyboardHintBar({ storageKey, items = [], children, sx = {} }) {
  const key = storageKey ? `kbdhint:${storageKey}` : null;
  const [dismissed, setDismissed] = useState(() => {
    if (!key) return false;
    try { return localStorage.getItem(key) === '1'; } catch { return false; }
  });

  if (dismissed) return null;

  const close = () => {
    setDismissed(true);
    if (key) {
      try { localStorage.setItem(key, '1'); } catch { /* storage unavailable — ignore */ }
    }
  };

  return (
    <Box sx={{
      display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5, px: 1.5, py: 0.75,
      borderRadius: 1, bgcolor: `${TEAL}0c`, border: `1px solid ${TEAL}22`, flexWrap: 'wrap', ...sx,
    }}>
      <Typography sx={{ fontSize: '0.72rem', color: '#555' }}>
        ⌨{' '}
        {children || items.map((it, i) => (
          <React.Fragment key={it.k}>
            {i > 0 && ' · '}
            <b>{it.k}</b> {it.label}
          </React.Fragment>
        ))}
      </Typography>
      <IconButton size="small" onClick={close} sx={{ ml: 'auto', p: 0.25, color: '#999' }}>
        <CloseIcon sx={{ fontSize: 15 }} />
      </IconButton>
    </Box>
  );
}
